import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import { IBeforeAfterRenderingImage } from '../interfaces/IBeforeAfterRenderingImage';

export const BEFORE_AFTER_RENDERING_IMAGES: IBeforeAfterRenderingImage[] = [
  {
    key: 0,
    heading: 'Before',
    tabletImage: (
      <StaticImage
        loading="eager"
        placeholder="blurred"
        src="../../v2/assets/images/rendering_before_1_tablet.png"
        alt="renderings-before-1"
      />
    ),
    desktopImage: (
      <StaticImage
        loading="eager"
        placeholder="blurred"
        src="../../v2/assets/images/rendering_before_1_desktop.png"
        alt="renderings-before-1"
      />
    ),
  },
  {
    key: 1,
    heading: 'After',
    tabletImage: (
      <StaticImage
        loading="eager"
        placeholder="blurred"
        src="../../v2/assets/images/rendering_after_1_tablet.png"
        alt="renderings-after-1"
      />
    ),
    desktopImage: (
      <StaticImage
        loading="eager"
        placeholder="blurred"
        src="../../v2/assets/images/rendering_after_1_desktop.png"
        alt="renderings-before-1"
      />
    ),
  },
  {
    key: 2,
    heading: 'Before',
    tabletImage: (
      <StaticImage
        loading="eager"
        placeholder="blurred"
        src="../../v2/assets/images/rendering_before_2_tablet.png"
        alt="renderings-before-2"
      />
    ),
    desktopImage: (
      <StaticImage
        loading="eager"
        placeholder="blurred"
        src="../../v2/assets/images/rendering_before_2_desktop.png"
        alt="renderings-before-1"
      />
    ),
  },
  {
    key: 3,
    heading: 'After',
    tabletImage: (
      <StaticImage
        loading="eager"
        placeholder="blurred"
        src="../../v2/assets/images/rendering_after_2_tablet.png"
        alt="renderings-after-2"
      />
    ),
    desktopImage: (
      <StaticImage
        loading="eager"
        placeholder="blurred"
        src="../../v2/assets/images/rendering_after_2_desktop.png"
        alt="renderings-before-1"
      />
    ),
  },
  {
    key: 4,
    heading: 'Before',
    tabletImage: (
      <StaticImage
        loading="eager"
        placeholder="blurred"
        src="../../v2/assets/images/rendering_before_3_tablet.png"
        alt="renderings-before-3"
      />
    ),
    desktopImage: (
      <StaticImage
        loading="eager"
        placeholder="blurred"
        src="../../v2/assets/images/rendering_before_3_desktop.png"
        alt="renderings-before-1"
      />
    ),
  },
  {
    key: 5,
    heading: 'After',
    tabletImage: (
      <StaticImage
        loading="eager"
        placeholder="blurred"
        src="../../v2/assets/images/rendering_after_3_tablet.png"
        alt="renderings-after-3"
      />
    ),
    desktopImage: (
      <StaticImage
        loading="eager"
        placeholder="blurred"
        src="../../v2/assets/images/rendering_after_3_desktop.png"
        alt="renderings-before-1"
      />
    ),
  },
];
